import Anchor from "atoms/anchors/anchor";
import { PhoneNumberConstants } from "constants/phone-number-constants";
import React, { PropsWithChildren } from "react";

interface SupportPhoneLinkProps {
    supportNumber: keyof typeof PhoneNumberConstants;
}

const SupportPhoneLink: React.FunctionComponent<
    PropsWithChildren<SupportPhoneLinkProps>
> = ({ supportNumber }: PropsWithChildren<SupportPhoneLinkProps>) => {
    const phoneNumber = PhoneNumberConstants[supportNumber];
    return (
        <Anchor cssClassName="-anchor" external to={`tel:${phoneNumber}`}>
            {phoneNumber}
        </Anchor>
    );
};

export default SupportPhoneLink;
